import i18next from "i18next"
import { isEmpty } from "lodash"

export const DEFAULT_LANGUAGE = "de"
export const SUPPORTED_LANGUAGES = ["de", "fr", "it"]

i18next.init({
  lng: DEFAULT_LANGUAGE,
  fallbackLng: DEFAULT_LANGUAGE,
  interpolation: {
    // React already does escaping
    escapeValue: false,
  },
})

SUPPORTED_LANGUAGES.forEach(lang => {
  const translation = require(`./${lang}.json`)
  i18next.addResourceBundle(lang, "translation", translation)
})

export default i18next

export function t(keys, options) {
  return i18next.t(keys, options)
}

export function tError(scope, errorOrArray) {
  const array = Array.isArray(errorOrArray) ? errorOrArray : [errorOrArray]
  return array
    .filter(Boolean)
    .map(error =>
      t([`${scope}.errors.${error.code}`, `common.errors.${error.code}`], {
        replace: { ...error.data, message: error.message },
        defaultValue: t([`${scope}.errors.unspecific`, "common.errors.unspecific"], {
          replace: {
            ...error.data,
            message: !isEmpty(error.message) ? error.message : JSON.stringify(error, null, 2).replace(/\n\s*/g, " "),
          },
          defaultValue: "Error: {{message}}",
        }),
      }),
    )
    .join("; ")
}



// WEBPACK FOOTER //
// ./src/i18next/index.js